import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { BaseComponent, UserService } from '@mypxplat/xplat/core';
import { BetaService } from '@mypxplat/xplat/web/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from "moment";

@Component({
  selector: 'myp-add-edit-beta-program',
  templateUrl: 'add-edit-beta-program.component.html'
})
export class AddEditBetaProgramComponent extends BaseComponent implements OnInit {

  @Input() program: any = {};
  public startDate: any;
  public loading: boolean = false;
  public endDate: any;
  @Output() programAdded: EventEmitter<any> = new EventEmitter();

  constructor(
    userService: UserService,
    public activeModal: NgbActiveModal,
    public betaService: BetaService
  ) {
    super(userService);
  }
  
  ngOnInit() {
    if (this.program.start_date) {
      this.startDate = {
        day: parseInt(moment(this.program.start_date).format('D')),
        month: parseInt(moment(this.program.start_date).format('M')),
        year: parseInt(moment(this.program.start_date).format('YYYY'))
      }
    }
    if (this.program.end_date) {
      this.endDate = {
        day: parseInt(moment(this.program.end_date).format('D')),
        month: parseInt(moment(this.program.end_date).format('M')),
        year: parseInt(moment(this.program.end_date).format('YYYY'))
      }
    }
  }

  submit() {
    if (this.startDate && this.startDate.day) {
      let day = this.startDate.day;
      if (day < 10) day = '0' + day;
      let month = this.startDate.month;
      if (month < 10) month = '0' + month;
      let date = this.startDate.year + '-' + month + '-' + day;
      this.program.start_date = date;
    }
    if (this.endDate && this.endDate.day) {
      let day = this.endDate.day;
      if (day < 10) day = '0' + day;
      let month = this.endDate.month;
      if (month < 10) month = '0' + month;
      let date = this.endDate.year + '-' + month + '-' + day;
      this.program.end_date = date;
    }
    this.betaService.createBeta(this.program).subscribe(result => {
      this.programAdded.next(result);
      this.activeModal.close();
    })
  }
}